export const getNettoWorkTime = (hours: string) => {
  const hoursPart = hours.split(":")[0];
  const minutesPart = hours.split(":")[1];
  return Number.parseInt(hoursPart) * 60 + Number.parseInt(minutesPart);
};
